import { render, staticRenderFns } from "./Sesion.vue?vue&type=template&id=2f2c5b30"
import script from "./Sesion.vue?vue&type=script&lang=js"
export * from "./Sesion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports